import React from 'react'

const Separator = () => {
  return (
        <div style={{
          borderColor: 'white',
          borderLeft: 'solid',
          borderWidth: '1px',
          height: '64px'
        }}> </div>
  )
}

export default Separator
